// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%27100%27 height=%27100%27 viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z%27 fill=%27rgba%28255,255,255,.03%29%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Chat Screen Styles */
:root {
    --primary-color: #2a9d8f;
    --primary-dark: #1e6e64;
    --primary-light: #8ecec3;
    --secondary-color: #e9c46a;
    --secondary-dark: #dda832;
    --secondary-light: #f4e1b0;
    --text-dark: #264653;
    --text-light: #ffffff;
    --background-light: #f8f9fa;
    --background-dark: #264653;
    --error-color: #e76f51;
    --success-color: #2a9d8f;
    --border-radius-sm: 8px;
    --border-radius-md: 16px;
    --border-radius-lg: 24px;
    --border-radius-xl: 32px;
    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
    --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);
    --transition-fast: 0.2s ease;
    --transition-normal: 0.3s ease;
    --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  .chatscreen-container {
    display: flex;
    flex-direction: column;
    height: 100dvh;
    width: 100%;
    background: linear-gradient(135deg, #264653, #2a9d8f);
    font-family: var(--font-family);
    -webkit-overflow-scrolling: touch;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    position: fixed;
    overflow-x: hidden;
  }
  
  /* Add subtle pattern overlay */
  .chatscreen-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 0.5;
    z-index: 1;
    pointer-events: none;
  }
  
  /* Header Styles */
  .chatscreen-header-container {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2dvh 3dvw;
    background: linear-gradient(to right, rgba(38, 70, 83, 0.9), rgba(42, 157, 143, 0.9));
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: sticky;
    top: 0;
    z-index: 100;
    padding-top: max(16px, env(safe-area-inset-top));
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
  }
  
  .chatscreen-header-title {
    color: var(--secondary-color);
    font-size: 1.8rem;
    font-weight: 700;
    text-align: center;
    margin: 0;
    letter-spacing: 1px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    background: linear-gradient(to right, var(--secondary-color), #f4e1b0);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
  }
  
  .chatscreen-header-title::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(to right, var(--secondary-color), #f4e1b0);
    border-radius: 3px;
  }
  
  .chatscreen-home-button {
    position: absolute;
    left: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    color: var(--secondary-color);
    border: 1px solid rgba(255, 255, 255, 0.2);
    font-size: 1.1rem;
    cursor: pointer;
    transition: all var(--transition-normal);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  .chatscreen-home-button:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: var(--secondary-color);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(233, 196, 106, 0.3);
  }
  
  .chatscreen-home-button:active {
    transform: translateY(0);
  }
  
  /* Messages Container */
  .chatscreen-messages-container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 2dvh 3dvw;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    scroll-behavior: smooth;
    position: relative;
    z-index: 10;
  }
  
  .chatscreen-messages-container::-webkit-scrollbar {
    width: 6px;
  }
  
  .chatscreen-messages-container::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: var(--border-radius-sm);
  }
  
  .chatscreen-messages-container::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: var(--border-radius-sm);
  }
  
  .chatscreen-messages-container::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
  
  /* Message Styles */
  .chatscreen-message-wrapper {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    animation: fadeIn 0.3s ease;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .user-message-wrapper {
    justify-content: flex-end;
  }
  
  .bot-message-wrapper {
    justify-content: flex-start;
  }
  
  .chatscreen-user-message,
  .chatscreen-bot-message {
    max-width: 80%;
    border-radius: var(--border-radius-lg);
    padding: 12px 16px;
    margin-bottom: 4px;
    box-shadow: var(--shadow-sm);
    line-height: 1.5;
    position: relative;
    overflow: hidden;
  }
  
  .chatscreen-user-message {
    background-color: var(--secondary-color);
    color: var(--text-dark);
    border-bottom-right-radius: 4px;
    align-self: flex-end;
  }
  
  .chatscreen-bot-message {
    background-color: rgba(255, 255, 255, 0.9);
    color: var(--text-dark);
    border-bottom-left-radius: 4px;
    align-self: flex-start;
  }
  
  .chatscreen-message-text {
    font-size: 16px;
    word-break: break-word;
  }
  
  /* Bot Profile and Actions */
  .bot-profile-and-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 8px;
  }
  
  .chatbot-profile-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--primary-light);
    box-shadow: var(--shadow-sm);
  }
  
  .bot-actions {
    display: flex;
    margin-top: 4px;
  }
  
  .thumb-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    padding: 4px;
    margin: 0 2px;
    color: var(--text-light);
    opacity: 0.7;
    transition: all var(--transition-fast);
  }
  
  .thumb-button:hover {
    opacity: 1;
    transform: scale(1.2);
  }
  
  .thumb-button:active {
    transform: scale(0.95);
  }
  
  /* Prompts Container */
  .chatscreen-prompts-container {
    display: flex;
    padding: 2dvh 3dvw;
    background-color: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border-top: none;
    gap: 12px;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap; /* Default wrap for desktop */
  }
  
  /* Mobile styles for prompts */
  @media (max-width: 768px) {
    /* Initial view - wrapped grid layout */
    .chatscreen-prompts-container.initial-view {
      flex-wrap: wrap;
      justify-content: center;
      overflow-x: visible;
      padding: 2dvh 3dvw;
    }

    /* After messages - horizontal scrollable row */
    .chatscreen-prompts-container.has-messages {
      flex-wrap: nowrap;
      justify-content: flex-start;
      overflow-x: auto;
      padding: 1.5dvh 3dvw;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
      margin-bottom: 1dvh;
      padding-bottom: 1dvh; /* Add padding to account for scroll space */
    }

    .chatscreen-prompts-container.has-messages::-webkit-scrollbar {
      display: none;
    }

    /* Adjust button styles in horizontal scroll mode */
    .chatscreen-prompts-container.has-messages .chatscreen-prompt-button {
      flex: 0 0 auto;
      margin-right: 8px;
      font-size: 13px; /* Slightly smaller font for better fit */
      padding: 8px 14px; /* Slightly smaller padding */
      white-space: nowrap;
    }

    /* Add padding to last button to ensure proper spacing when scrolling */
    .chatscreen-prompts-container.has-messages .chatscreen-prompt-button:last-child {
      margin-right: 3dvw;
    }
  }
  
  .chatscreen-prompt-button {
    background-color: var(--secondary-color);
    color: var(--text-dark);
    font-weight: 500;
    padding: 10px 16px;
    border-radius: var(--border-radius-md);
    border: none;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    box-shadow: var(--shadow-sm);
    transition: all var(--transition-normal);
  }
  
  .chatscreen-prompt-button:hover {
    background-color: var(--secondary-dark);
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }
  
  .chatscreen-prompt-button:active {
    transform: translateY(0);
  }
  
  /* Input Container as an Island */
  .chatscreen-input-container {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: var(--border-radius-xl);
    position: relative;
    z-index: 100;
    margin: 2dvh auto;
    width: 90%;
    max-width: 800px;
    box-shadow: var(--shadow-md);
    transition: all var(--transition-normal);
    align-self: center;
  }
  
  .chatscreen-input-container:hover {
    box-shadow: var(--shadow-lg);
    transform: translateY(-2px);
    border-color: rgba(255, 255, 255, 0.5);
  }
  
  .chatscreen-input {
    flex: 1 1;
    height: 48px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: var(--border-radius-md);
    padding: 0 16px;
    margin-right: 12px;
    background-color: rgba(255, 255, 255, 0.9);
    color: var(--text-dark);
    font-size: 16px;
    transition: all var(--transition-normal);
    box-shadow: var(--shadow-sm);
    min-width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  
  .chatscreen-input:focus {
    outline: none;
    border-color: var(--secondary-color);
    box-shadow: 0 0 0 2px rgba(233, 196, 106, 0.3);
  }
  
  .chatscreen-send-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: var(--secondary-color);
    color: var(--text-dark);
    border: none;
    cursor: pointer;
    transition: all var(--transition-normal);
    box-shadow: var(--shadow-sm);
    flex-shrink: 0;
  }
  
  .chatscreen-send-button:hover {
    background-color: var(--secondary-dark);
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }
  
  .chatscreen-send-button:active {
    transform: translateY(0);
  }
  
  /* Typing Indicator */
  .typing-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    margin: 8px 0;
  }
  
  .typing-indicator-dot {
    background-color: var(--text-light);
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin: 0 2px;
    opacity: 0.7;
    animation: dot-flashing 1s infinite linear alternate;
  }
  
  .typing-indicator-dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .typing-indicator-dot:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes dot-flashing {
    0% {
      opacity: 0.2;
      transform: scale(0.8);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0.2;
      transform: scale(0.8);
    }
  }
  
  /* File Upload Styles */
  .custom-file-upload {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.3);
    color: var(--text-dark);
    border: none;
    cursor: pointer;
    margin-right: 12px;
    transition: all var(--transition-normal);
    box-shadow: var(--shadow-sm);
    flex-shrink: 0;
  }
  
  .custom-file-upload:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
  
  .uploaded-files-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
    padding: 0 20px;
  }
  
  .uploaded-file-item {
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: var(--border-radius-sm);
    padding: 6px 12px;
    font-size: 14px;
    color: var(--text-dark);
    box-shadow: var(--shadow-sm);
  }
  
  .uploaded-file-item span {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 8px;
  }
  
  .remove-file-button {
    background: none;
    border: none;
    color: var(--error-color);
    cursor: pointer;
    font-size: 16px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .remove-file-button:hover {
    transform: scale(1.2);
  }
  
  /* Message Image */
  .chatscreen-message-image {
    max-width: 300px;
    margin: 0 auto 20px;
    border-radius: var(--border-radius-sm);
    overflow: hidden;
    text-align: center;
    position: relative;
  }
  
  .chatscreen-message-image::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, rgba(233, 196, 106, 0.2) 0%, rgba(233, 196, 106, 0) 70%);
    pointer-events: none;
  }
  
  /* Default styling for all chatbot images (unchanged) */
  .chatscreen-message-image img {
    max-width: 100%;
    max-height: 200px;
    height: auto;
    display: block;
    margin: 0 auto;
    object-fit: contain;
  }
  
  /* Special styling ONLY for PaliGPT image */
  .palestine-theme .chatscreen-message-image img {
    border-radius: 24px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    border: 3px solid rgba(255, 255, 255, 0.2);
  }
  
  /* Floating Prompts Container */
  .floating-prompts-container {
    display: flex;
    flex-wrap: wrap;           /* Changed from nowrap to wrap */
    justify-content: center;   /* Changed from left to center */
    gap: 12px;
    padding: 2dvh 3dvw;       /* Changed to dynamic viewport units */
    margin: 0 auto;
    max-width: 800px;
    position: relative;
    z-index: 10;
    overflow-x: visible;      /* Changed from auto to visible */
  }
  
  .floating-prompt-button {
    background-color: var(--secondary-color);
    color: var(--text-dark);
    font-weight: 500;
    padding: 10px 16px;
    border-radius: var(--border-radius-md);
    border: none;
    font-size: 14px;
    cursor: pointer;
    box-shadow: var(--shadow-md);
    transition: all var(--transition-normal);
    animation: floatUp 0.5s ease-out forwards;
    margin: 5px;
  }
  
  .floating-prompt-button:hover {
    background-color: var(--secondary-dark);
    transform: translateY(-8px) scale(1.05);
    box-shadow: var(--shadow-lg);
  }
  
  .floating-prompt-button:active {
    transform: translateY(0);
  }
  
  @keyframes floatUp {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    60% {
      opacity: 1;
      transform: translateY(-10px);
    }
    80% {
      transform: translateY(5px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Responsive Design */
  @media (min-width: 1200px) {
    .chatscreen-messages-container {
      max-width: 1000px;
    }
    
    .chatscreen-header-title {
      font-size: 2rem;
    }
  }
  
  @media (min-width: 768px) and (max-width: 1199px) {
    .chatscreen-messages-container {
      max-width: 90%;
    }
    
    .chatscreen-header-title {
      font-size: 1.8rem;
    }
  }
  
  @media (max-width: 767px) {
    .chatscreen-messages-container {
      padding: 16px;
      max-width: 100%;
    }
    
    .chatscreen-header-title {
      font-size: 1.6rem;
    }
    
    .chatscreen-header-title::after {
      width: 50px;
    }
    
    .chatscreen-home-button {
      left: 16px; /* Adjusted for smaller screens */
    }
    
    .chatscreen-user-message,
    .chatscreen-bot-message {
      max-width: 85%;
    }
  }
  
  @media (max-width: 480px) {
    .chatscreen-header-container {
      padding: 12px 16px;
    }
    
    .chatscreen-header-title {
      font-size: 1.4rem;
    }
    
    .chatscreen-header-title::after {
      width: 40px;
      height: 2px;
      bottom: -4px;
    }
    
    .chatscreen-home-button {
      width: 32px;
      height: 32px;
      font-size: 0.9rem;
      left: 12px; /* Further adjusted for very small screens */
      border-radius: 6px;
    }
    
    .chatscreen-input-container {
      padding: 8px 12px;
      margin-top: 10px;
      width: 95%;
    }
    
    .chatscreen-input {
      height: 40px;
      font-size: 16px;
      padding: 0 10px;
      margin-right: 8px;
    }
    
    .chatscreen-send-button {
      width: 40px;
      height: 40px;
      min-width: 40px;
    }
    
    .custom-file-upload {
      width: 40px;
      height: 40px;
      min-width: 40px;
      margin-right: 8px;
    }
    
    .chatscreen-message-text {
      font-size: 15px;
    }
    
    .chatbot-profile-image {
      width: 36px;
      height: 36px;
    }
  }
  
  /* Extra small devices */
  @media (max-width: 360px) {
    .chatscreen-input-container {
      padding: 6px 10px;
      width: 98%;
    }
    
    .chatscreen-input {
      height: 36px;
      font-size: 14px;
      padding: 0 8px;
      margin-right: 6px;
      min-width: 50px;
    }
    
    .chatscreen-send-button, 
    .custom-file-upload {
      width: 36px;
      height: 36px;
      min-width: 36px;
      flex-shrink: 0;
    }
    
    .custom-file-upload {
      margin-right: 6px;
    }
    
    .chatscreen-header-title {
      font-size: 1.2rem; /* Smaller font size for very small screens */
    }
    
    .chatscreen-home-button {
      width: 28px;
      height: 28px;
      font-size: 0.8rem;
      left: 10px; /* Further adjusted for extremely small screens */
      border-radius: 6px;
    }
  }
  
  /* Prompt Count Info */
  .prompt-count-info {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    color: var(--text-light);
    font-size: 14px;
  }
  
  .prompt-count-text {
    margin-right: 8px;
  }
  
  .upgrade-message {
    color: var(--secondary-color);
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
    text-decoration: underline;
  }
  
  .upgrade-message:hover {
    color: var(--secondary-light);
  }
  
  /* Center content container for image and prompts */
  .center-content-container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    padding: 2dvh 3dvw;
    margin: 0 auto;
    z-index: 5;
  }
  
  /* Container for the entire chat area */
  .chat-area-container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    overflow-y: auto;
    z-index: 2;
    height: calc(100dvh - 15dvh);
  }
  
  .chat-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
    padding-top: 10px;
  }
  
  /* When there are no messages, position the input at the bottom */
  .chat-area-container:only-child {
    justify-content: space-between;
  }
  
  .lantern-container {
    position: absolute;
    top: 10dvh;
    z-index: 15;
    animation: sway 3s linear infinite;
  }
  
  .lantern-container img {
    width: 60px;
    height: auto;
    filter: drop-shadow(0 0 10px rgba(255, 223, 0, 0.8));
  }
  
  .lantern-left {
    left: 20px;
  }
  
  .lantern-right {
    right: 20px;
  }
  
  @keyframes sway {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(7deg);
    }
    75% {
      transform: rotate(-7deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  .scroll-to-bottom-button {
    position: absolute;
    bottom: 20dvh;
    left: 50%;
    transform: translateX(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 20px;
    font-size: 1rem;
    white-space: nowrap;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: background-color 0.2s ease, width 0.2s ease;
    z-index: 100;
  }
  
  .scroll-to-bottom-button:hover {
    background-color: #f0f0f0;
  }
  
  /* mic Styles */
  .custom-mic {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.3);
    color: var(--text-dark);
    border: none;
    cursor: pointer;
    margin-right: 12px;
    transition: all var(--transition-normal);
    box-shadow: var(--shadow-sm);
    flex-shrink: 0;
  }
  
  .custom-mic:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }`, "",{"version":3,"sources":["webpack://./src/chat/chatScreen.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,yCAAyC;IACzC,yCAAyC;IACzC,0CAA0C;IAC1C,4BAA4B;IAC5B,8BAA8B;IAC9B,mJAAmJ;EACrJ;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,qDAAqD;IACrD,+BAA+B;IAC/B,iCAAiC;IACjC,qCAAqC;IACrC,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA+tC;IAC/tC,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;;EAEA,kBAAkB;EAClB;IACE,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qFAAqF;IACrF,2BAA2B;IAC3B,mCAAmC;IACnC,iDAAiD;IACjD,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,gDAAgD;IAChD,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,yCAAyC;IACzC,sEAAsE;IACtE,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,sEAAsE;IACtE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,kCAAkC;IAClC,6BAA6B;IAC7B,0CAA0C;IAC1C,iBAAiB;IACjB,eAAe;IACf,wCAAwC;IACxC,yCAAyC;EAC3C;;EAEA;IACE,qCAAqC;IACrC,oCAAoC;IACpC,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,uBAAuB;EACvB;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oCAAoC;IACpC,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;IAC1C,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;EAC7C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;IACxC,uBAAuB;IACvB,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,0CAA0C;IAC1C,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,YAAY;IACZ,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,eAAe,EAAE,6BAA6B;EAChD;;EAEA,8BAA8B;EAC9B;IACE,uCAAuC;IACvC;MACE,eAAe;MACf,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA,+CAA+C;IAC/C;MACE,iBAAiB;MACjB,2BAA2B;MAC3B,gBAAgB;MAChB,oBAAoB;MACpB,iCAAiC;MACjC,qBAAqB;MACrB,wBAAwB;MACxB,mBAAmB;MACnB,oBAAoB,EAAE,4CAA4C;IACpE;;IAEA;MACE,aAAa;IACf;;IAEA,mDAAmD;IACnD;MACE,cAAc;MACd,iBAAiB;MACjB,eAAe,EAAE,yCAAyC;MAC1D,iBAAiB,EAAE,6BAA6B;MAChD,mBAAmB;IACrB;;IAEA,uEAAuE;IACvE;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,wCAAwC;IACxC,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,4BAA4B;IAC5B,wCAAwC;EAC1C;;EAEA;IACE,uCAAuC;IACvC,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,iCAAiC;EACjC;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,2BAA2B;IAC3B,mCAAmC;IACnC,0CAA0C;IAC1C,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,4BAA4B;IAC5B,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,0CAA0C;IAC1C,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,0CAA0C;IAC1C,uBAAuB;IACvB,eAAe;IACf,wCAAwC;IACxC,4BAA4B;IAC5B,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,wCAAwC;IACxC,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,uCAAuC;IACvC,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mCAAmC;IACnC,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,YAAY;IACZ,oDAAoD;EACtD;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,YAAY;MACZ,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;IACA;MACE,YAAY;MACZ,qBAAqB;IACvB;EACF;;EAEA,uBAAuB;EACvB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,sCAAsC;IACtC,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA,kBAAkB;EAClB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sGAAsG;IACtG,oBAAoB;EACtB;;EAEA,uDAAuD;EACvD;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,cAAc;IACd,mBAAmB;EACrB;;EAEA,2CAA2C;EAC3C;IACE,mBAAmB;IACnB,0CAA0C;IAC1C,0CAA0C;EAC5C;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,eAAe,YAAY,gCAAgC;IAC3D,uBAAuB,IAAI,gCAAgC;IAC3D,SAAS;IACT,kBAAkB,QAAQ,sCAAsC;IAChE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB,OAAO,iCAAiC;EAC7D;;EAEA;IACE,wCAAwC;IACxC,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,wCAAwC;IACxC,yCAAyC;IACzC,WAAW;EACb;;EAEA;IACE,uCAAuC;IACvC,uCAAuC;IACvC,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,sBAAsB;EACtB;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,aAAa;MACb,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,UAAU,EAAE,iCAAiC;IAC/C;;IAEA;;MAEE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,UAAU,EAAE,4CAA4C;MACxD,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,eAAe;MACf,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA,wBAAwB;EACxB;IACE;MACE,iBAAiB;MACjB,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,eAAe;IACjB;;IAEA;;MAEE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB,EAAE,6CAA6C;IAClE;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,UAAU,EAAE,iDAAiD;MAC7D,kBAAkB;IACpB;EACF;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,0CAA0C;IAC1C,0BAA0B;IAC1B,kCAAkC;IAClC,8CAA8C;IAC9C,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,mDAAmD;EACnD;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,UAAU;EACZ;;EAEA,uCAAuC;EACvC;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;EACnB;;EAEA,iEAAiE;EACjE;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oDAAoD;EACtD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,uBAAuB;IACzB;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,uBAAuB;IACzB;EACF;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,yCAAyC;IACzC,uDAAuD;IACvD,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,eAAe;EACf;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,0CAA0C;EAC5C","sourcesContent":["/* Modern Chat Screen Styles */\n:root {\n    --primary-color: #2a9d8f;\n    --primary-dark: #1e6e64;\n    --primary-light: #8ecec3;\n    --secondary-color: #e9c46a;\n    --secondary-dark: #dda832;\n    --secondary-light: #f4e1b0;\n    --text-dark: #264653;\n    --text-light: #ffffff;\n    --background-light: #f8f9fa;\n    --background-dark: #264653;\n    --error-color: #e76f51;\n    --success-color: #2a9d8f;\n    --border-radius-sm: 8px;\n    --border-radius-md: 16px;\n    --border-radius-lg: 24px;\n    --border-radius-xl: 32px;\n    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);\n    --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.1);\n    --shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.1);\n    --transition-fast: 0.2s ease;\n    --transition-normal: 0.3s ease;\n    --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  }\n  \n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .chatscreen-container {\n    display: flex;\n    flex-direction: column;\n    height: 100dvh;\n    width: 100%;\n    background: linear-gradient(135deg, #264653, #2a9d8f);\n    font-family: var(--font-family);\n    -webkit-overflow-scrolling: touch;\n    padding-top: env(safe-area-inset-top);\n    padding-bottom: env(safe-area-inset-bottom);\n    position: fixed;\n    overflow-x: hidden;\n  }\n  \n  /* Add subtle pattern overlay */\n  .chatscreen-container::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='rgba(255,255,255,.03)' fill-rule='evenodd'/%3E%3C/svg%3E\");\n    opacity: 0.5;\n    z-index: 1;\n    pointer-events: none;\n  }\n  \n  /* Header Styles */\n  .chatscreen-header-container {\n    flex: 0 0 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2dvh 3dvw;\n    background: linear-gradient(to right, rgba(38, 70, 83, 0.9), rgba(42, 157, 143, 0.9));\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    padding-top: max(16px, env(safe-area-inset-top));\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    position: relative;\n  }\n  \n  .chatscreen-header-title {\n    color: var(--secondary-color);\n    font-size: 1.8rem;\n    font-weight: 700;\n    text-align: center;\n    margin: 0;\n    letter-spacing: 1px;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    background: linear-gradient(to right, var(--secondary-color), #f4e1b0);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    position: relative;\n  }\n  \n  .chatscreen-header-title::after {\n    content: '';\n    position: absolute;\n    bottom: -6px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 60px;\n    height: 3px;\n    background: linear-gradient(to right, var(--secondary-color), #f4e1b0);\n    border-radius: 3px;\n  }\n  \n  .chatscreen-home-button {\n    position: absolute;\n    left: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.15);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    color: var(--secondary-color);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    font-size: 1.1rem;\n    cursor: pointer;\n    transition: all var(--transition-normal);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .chatscreen-home-button:hover {\n    background: rgba(255, 255, 255, 0.25);\n    border-color: var(--secondary-color);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(233, 196, 106, 0.3);\n  }\n  \n  .chatscreen-home-button:active {\n    transform: translateY(0);\n  }\n  \n  /* Messages Container */\n  .chatscreen-messages-container {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    padding: 2dvh 3dvw;\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    scroll-behavior: smooth;\n    position: relative;\n    z-index: 10;\n  }\n  \n  .chatscreen-messages-container::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  .chatscreen-messages-container::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: var(--border-radius-sm);\n  }\n  \n  .chatscreen-messages-container::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.3);\n    border-radius: var(--border-radius-sm);\n  }\n  \n  .chatscreen-messages-container::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(255, 255, 255, 0.5);\n  }\n  \n  /* Message Styles */\n  .chatscreen-message-wrapper {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 16px;\n    animation: fadeIn 0.3s ease;\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n  }\n  \n  .user-message-wrapper {\n    justify-content: flex-end;\n  }\n  \n  .bot-message-wrapper {\n    justify-content: flex-start;\n  }\n  \n  .chatscreen-user-message,\n  .chatscreen-bot-message {\n    max-width: 80%;\n    border-radius: var(--border-radius-lg);\n    padding: 12px 16px;\n    margin-bottom: 4px;\n    box-shadow: var(--shadow-sm);\n    line-height: 1.5;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .chatscreen-user-message {\n    background-color: var(--secondary-color);\n    color: var(--text-dark);\n    border-bottom-right-radius: 4px;\n    align-self: flex-end;\n  }\n  \n  .chatscreen-bot-message {\n    background-color: rgba(255, 255, 255, 0.9);\n    color: var(--text-dark);\n    border-bottom-left-radius: 4px;\n    align-self: flex-start;\n  }\n  \n  .chatscreen-message-text {\n    font-size: 16px;\n    word-break: break-word;\n  }\n  \n  /* Bot Profile and Actions */\n  .bot-profile-and-actions {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-right: 8px;\n  }\n  \n  .chatbot-profile-image {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid var(--primary-light);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .bot-actions {\n    display: flex;\n    margin-top: 4px;\n  }\n  \n  .thumb-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    padding: 4px;\n    margin: 0 2px;\n    color: var(--text-light);\n    opacity: 0.7;\n    transition: all var(--transition-fast);\n  }\n  \n  .thumb-button:hover {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n  \n  .thumb-button:active {\n    transform: scale(0.95);\n  }\n  \n  /* Prompts Container */\n  .chatscreen-prompts-container {\n    display: flex;\n    padding: 2dvh 3dvw;\n    background-color: transparent;\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n    border-top: none;\n    gap: 12px;\n    justify-content: center;\n    width: 100%;\n    margin: 0 auto;\n    flex-wrap: wrap; /* Default wrap for desktop */\n  }\n  \n  /* Mobile styles for prompts */\n  @media (max-width: 768px) {\n    /* Initial view - wrapped grid layout */\n    .chatscreen-prompts-container.initial-view {\n      flex-wrap: wrap;\n      justify-content: center;\n      overflow-x: visible;\n      padding: 2dvh 3dvw;\n    }\n\n    /* After messages - horizontal scrollable row */\n    .chatscreen-prompts-container.has-messages {\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      overflow-x: auto;\n      padding: 1.5dvh 3dvw;\n      -webkit-overflow-scrolling: touch;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n      margin-bottom: 1dvh;\n      padding-bottom: 1dvh; /* Add padding to account for scroll space */\n    }\n\n    .chatscreen-prompts-container.has-messages::-webkit-scrollbar {\n      display: none;\n    }\n\n    /* Adjust button styles in horizontal scroll mode */\n    .chatscreen-prompts-container.has-messages .chatscreen-prompt-button {\n      flex: 0 0 auto;\n      margin-right: 8px;\n      font-size: 13px; /* Slightly smaller font for better fit */\n      padding: 8px 14px; /* Slightly smaller padding */\n      white-space: nowrap;\n    }\n\n    /* Add padding to last button to ensure proper spacing when scrolling */\n    .chatscreen-prompts-container.has-messages .chatscreen-prompt-button:last-child {\n      margin-right: 3dvw;\n    }\n  }\n  \n  .chatscreen-prompt-button {\n    background-color: var(--secondary-color);\n    color: var(--text-dark);\n    font-weight: 500;\n    padding: 10px 16px;\n    border-radius: var(--border-radius-md);\n    border: none;\n    font-size: 14px;\n    cursor: pointer;\n    white-space: nowrap;\n    flex-shrink: 0;\n    box-shadow: var(--shadow-sm);\n    transition: all var(--transition-normal);\n  }\n  \n  .chatscreen-prompt-button:hover {\n    background-color: var(--secondary-dark);\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-md);\n  }\n  \n  .chatscreen-prompt-button:active {\n    transform: translateY(0);\n  }\n  \n  /* Input Container as an Island */\n  .chatscreen-input-container {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    background-color: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: var(--border-radius-xl);\n    position: relative;\n    z-index: 100;\n    margin: 2dvh auto;\n    width: 90%;\n    max-width: 800px;\n    box-shadow: var(--shadow-md);\n    transition: all var(--transition-normal);\n    align-self: center;\n  }\n  \n  .chatscreen-input-container:hover {\n    box-shadow: var(--shadow-lg);\n    transform: translateY(-2px);\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n  \n  .chatscreen-input {\n    flex: 1;\n    height: 48px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: var(--border-radius-md);\n    padding: 0 16px;\n    margin-right: 12px;\n    background-color: rgba(255, 255, 255, 0.9);\n    color: var(--text-dark);\n    font-size: 16px;\n    transition: all var(--transition-normal);\n    box-shadow: var(--shadow-sm);\n    min-width: 0;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n  \n  .chatscreen-input:focus {\n    outline: none;\n    border-color: var(--secondary-color);\n    box-shadow: 0 0 0 2px rgba(233, 196, 106, 0.3);\n  }\n  \n  .chatscreen-send-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background-color: var(--secondary-color);\n    color: var(--text-dark);\n    border: none;\n    cursor: pointer;\n    transition: all var(--transition-normal);\n    box-shadow: var(--shadow-sm);\n    flex-shrink: 0;\n  }\n  \n  .chatscreen-send-button:hover {\n    background-color: var(--secondary-dark);\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-md);\n  }\n  \n  .chatscreen-send-button:active {\n    transform: translateY(0);\n  }\n  \n  /* Typing Indicator */\n  .typing-indicator {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 24px;\n    margin: 8px 0;\n  }\n  \n  .typing-indicator-dot {\n    background-color: var(--text-light);\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n    margin: 0 2px;\n    opacity: 0.7;\n    animation: dot-flashing 1s infinite linear alternate;\n  }\n  \n  .typing-indicator-dot:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  \n  .typing-indicator-dot:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n  \n  @keyframes dot-flashing {\n    0% {\n      opacity: 0.2;\n      transform: scale(0.8);\n    }\n    50% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    100% {\n      opacity: 0.2;\n      transform: scale(0.8);\n    }\n  }\n  \n  /* File Upload Styles */\n  .custom-file-upload {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.3);\n    color: var(--text-dark);\n    border: none;\n    cursor: pointer;\n    margin-right: 12px;\n    transition: all var(--transition-normal);\n    box-shadow: var(--shadow-sm);\n    flex-shrink: 0;\n  }\n  \n  .custom-file-upload:hover {\n    background-color: rgba(255, 255, 255, 0.5);\n  }\n  \n  .uploaded-files-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 12px;\n    padding: 0 20px;\n  }\n  \n  .uploaded-file-item {\n    display: flex;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.8);\n    border-radius: var(--border-radius-sm);\n    padding: 6px 12px;\n    font-size: 14px;\n    color: var(--text-dark);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .uploaded-file-item span {\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-right: 8px;\n  }\n  \n  .remove-file-button {\n    background: none;\n    border: none;\n    color: var(--error-color);\n    cursor: pointer;\n    font-size: 16px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .remove-file-button:hover {\n    transform: scale(1.2);\n  }\n  \n  /* Message Image */\n  .chatscreen-message-image {\n    max-width: 300px;\n    margin: 0 auto 20px;\n    border-radius: var(--border-radius-sm);\n    overflow: hidden;\n    text-align: center;\n    position: relative;\n  }\n  \n  .chatscreen-message-image::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: radial-gradient(circle at center, rgba(233, 196, 106, 0.2) 0%, rgba(233, 196, 106, 0) 70%);\n    pointer-events: none;\n  }\n  \n  /* Default styling for all chatbot images (unchanged) */\n  .chatscreen-message-image img {\n    max-width: 100%;\n    max-height: 200px;\n    height: auto;\n    display: block;\n    margin: 0 auto;\n    object-fit: contain;\n  }\n  \n  /* Special styling ONLY for PaliGPT image */\n  .palestine-theme .chatscreen-message-image img {\n    border-radius: 24px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n    border: 3px solid rgba(255, 255, 255, 0.2);\n  }\n  \n  /* Floating Prompts Container */\n  .floating-prompts-container {\n    display: flex;\n    flex-wrap: wrap;           /* Changed from nowrap to wrap */\n    justify-content: center;   /* Changed from left to center */\n    gap: 12px;\n    padding: 2dvh 3dvw;       /* Changed to dynamic viewport units */\n    margin: 0 auto;\n    max-width: 800px;\n    position: relative;\n    z-index: 10;\n    overflow-x: visible;      /* Changed from auto to visible */\n  }\n  \n  .floating-prompt-button {\n    background-color: var(--secondary-color);\n    color: var(--text-dark);\n    font-weight: 500;\n    padding: 10px 16px;\n    border-radius: var(--border-radius-md);\n    border: none;\n    font-size: 14px;\n    cursor: pointer;\n    box-shadow: var(--shadow-md);\n    transition: all var(--transition-normal);\n    animation: floatUp 0.5s ease-out forwards;\n    margin: 5px;\n  }\n  \n  .floating-prompt-button:hover {\n    background-color: var(--secondary-dark);\n    transform: translateY(-8px) scale(1.05);\n    box-shadow: var(--shadow-lg);\n  }\n  \n  .floating-prompt-button:active {\n    transform: translateY(0);\n  }\n  \n  @keyframes floatUp {\n    0% {\n      opacity: 0;\n      transform: translateY(30px);\n    }\n    60% {\n      opacity: 1;\n      transform: translateY(-10px);\n    }\n    80% {\n      transform: translateY(5px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  /* Responsive Design */\n  @media (min-width: 1200px) {\n    .chatscreen-messages-container {\n      max-width: 1000px;\n    }\n    \n    .chatscreen-header-title {\n      font-size: 2rem;\n    }\n  }\n  \n  @media (min-width: 768px) and (max-width: 1199px) {\n    .chatscreen-messages-container {\n      max-width: 90%;\n    }\n    \n    .chatscreen-header-title {\n      font-size: 1.8rem;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .chatscreen-messages-container {\n      padding: 16px;\n      max-width: 100%;\n    }\n    \n    .chatscreen-header-title {\n      font-size: 1.6rem;\n    }\n    \n    .chatscreen-header-title::after {\n      width: 50px;\n    }\n    \n    .chatscreen-home-button {\n      left: 16px; /* Adjusted for smaller screens */\n    }\n    \n    .chatscreen-user-message,\n    .chatscreen-bot-message {\n      max-width: 85%;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .chatscreen-header-container {\n      padding: 12px 16px;\n    }\n    \n    .chatscreen-header-title {\n      font-size: 1.4rem;\n    }\n    \n    .chatscreen-header-title::after {\n      width: 40px;\n      height: 2px;\n      bottom: -4px;\n    }\n    \n    .chatscreen-home-button {\n      width: 32px;\n      height: 32px;\n      font-size: 0.9rem;\n      left: 12px; /* Further adjusted for very small screens */\n      border-radius: 6px;\n    }\n    \n    .chatscreen-input-container {\n      padding: 8px 12px;\n      margin-top: 10px;\n      width: 95%;\n    }\n    \n    .chatscreen-input {\n      height: 40px;\n      font-size: 16px;\n      padding: 0 10px;\n      margin-right: 8px;\n    }\n    \n    .chatscreen-send-button {\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n    }\n    \n    .custom-file-upload {\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      margin-right: 8px;\n    }\n    \n    .chatscreen-message-text {\n      font-size: 15px;\n    }\n    \n    .chatbot-profile-image {\n      width: 36px;\n      height: 36px;\n    }\n  }\n  \n  /* Extra small devices */\n  @media (max-width: 360px) {\n    .chatscreen-input-container {\n      padding: 6px 10px;\n      width: 98%;\n    }\n    \n    .chatscreen-input {\n      height: 36px;\n      font-size: 14px;\n      padding: 0 8px;\n      margin-right: 6px;\n      min-width: 50px;\n    }\n    \n    .chatscreen-send-button, \n    .custom-file-upload {\n      width: 36px;\n      height: 36px;\n      min-width: 36px;\n      flex-shrink: 0;\n    }\n    \n    .custom-file-upload {\n      margin-right: 6px;\n    }\n    \n    .chatscreen-header-title {\n      font-size: 1.2rem; /* Smaller font size for very small screens */\n    }\n    \n    .chatscreen-home-button {\n      width: 28px;\n      height: 28px;\n      font-size: 0.8rem;\n      left: 10px; /* Further adjusted for extremely small screens */\n      border-radius: 6px;\n    }\n  }\n  \n  /* Prompt Count Info */\n  .prompt-count-info {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 16px;\n    background-color: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    color: var(--text-light);\n    font-size: 14px;\n  }\n  \n  .prompt-count-text {\n    margin-right: 8px;\n  }\n  \n  .upgrade-message {\n    color: var(--secondary-color);\n    font-weight: 500;\n    cursor: pointer;\n    transition: all var(--transition-fast);\n    text-decoration: underline;\n  }\n  \n  .upgrade-message:hover {\n    color: var(--secondary-light);\n  }\n  \n  /* Center content container for image and prompts */\n  .center-content-container {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    position: relative;\n    padding: 2dvh 3dvw;\n    margin: 0 auto;\n    z-index: 5;\n  }\n  \n  /* Container for the entire chat area */\n  .chat-area-container {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    position: relative;\n    overflow-y: auto;\n    z-index: 2;\n    height: calc(100dvh - 15dvh);\n  }\n  \n  .chat-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    z-index: 2;\n    padding-top: 10px;\n  }\n  \n  /* When there are no messages, position the input at the bottom */\n  .chat-area-container:only-child {\n    justify-content: space-between;\n  }\n  \n  .lantern-container {\n    position: absolute;\n    top: 10dvh;\n    z-index: 15;\n    animation: sway 3s linear infinite;\n  }\n  \n  .lantern-container img {\n    width: 60px;\n    height: auto;\n    filter: drop-shadow(0 0 10px rgba(255, 223, 0, 0.8));\n  }\n  \n  .lantern-left {\n    left: 20px;\n  }\n  \n  .lantern-right {\n    right: 20px;\n  }\n  \n  @keyframes sway {\n    0% {\n      transform: rotate(0deg);\n    }\n    25% {\n      transform: rotate(7deg);\n    }\n    75% {\n      transform: rotate(-7deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n  .scroll-to-bottom-button {\n    position: absolute;\n    bottom: 20dvh;\n    left: 50%;\n    transform: translateX(-50%);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 16px;\n    background-color: #ffffff;\n    border: 1px solid #ccc;\n    border-radius: 20px;\n    font-size: 1rem;\n    white-space: nowrap;\n    cursor: pointer;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n    transition: background-color 0.2s ease, width 0.2s ease;\n    z-index: 100;\n  }\n  \n  .scroll-to-bottom-button:hover {\n    background-color: #f0f0f0;\n  }\n  \n  /* mic Styles */\n  .custom-mic {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.3);\n    color: var(--text-dark);\n    border: none;\n    cursor: pointer;\n    margin-right: 12px;\n    transition: all var(--transition-normal);\n    box-shadow: var(--shadow-sm);\n    flex-shrink: 0;\n  }\n  \n  .custom-mic:hover {\n    background-color: rgba(255, 255, 255, 0.5);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
